import {
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes,
} from '@angular/animations';

export const widen = trigger('widen', [
  state(
    'open',
    style({
      'max-width': '1000px',
      opacity: 1,
      overflow: 'visible',
    })
  ),
  state(
    'closed',
    style({
      'max-width': '0px',
      opacity: 0,
      overflow: 'hidden',
    })
  ),
  transition('open => closed', [
    animate(
      '0.7s',
      keyframes([
        style({
          opacity: 1,
          'max-width': '1000px',
          overflow: 'visible',
          offset: 0,
        }),
        style({
          opacity: 0,
          'max-width': '1000px',
          overflow: 'hidden',
          offset: 0.2,
        }),
        style({
          opacity: 0,
          'max-width': '0px',
          overflow: 'hidden',
          offset: 0.7,
        }),
      ])
    ),
  ]),
  transition('closed => open', [
    animate(
      '0.7s',
      keyframes([
        style({
          opacity: 0,
          'max-width': '0px',
          overflow: 'hidden',
          offset: 0,
        }),
        style({
          opacity: 0,
          'max-width': '1000px',
          overflow: 'hidden',
          offset: 0.5,
        }),
        style({
          opacity: 1,
          'max-width': '1000px',
          overflow: 'visible',
          offset: 0.7,
        }),
      ])
    ),
  ]),
]);
